import React from 'react';
import { Flex, Button, Form, Input, message, Radio } from 'antd';
import "./login.css"
// import PWAInstall from '../../components/pwa-install'
import { sendUserLoginToApp } from '../../utils/app-bridge';
import { detectWebView } from '../../utils/webview';

const { isWebView } = detectWebView();

const Login = (props) => {
    const [loginForm] = Form.useForm();

    React.useEffect(() => {
        sendUserLoginToApp({});
    }, []);
    const onSubmit = async () => {
        // document.getElementById('loginForm').submit();
        let response = await fetch('/api/auth/virify', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(loginForm.getFieldsValue())
        });

        let result = await response.json();

        if(result && result.success) {
            
            const { accStatus, accId, userId } = result.data;
            // 获取URL returnUrl参数
            const url = new URL(window.location.href);
            let returnUrl = url.searchParams.get('return_url');
            returnUrl = returnUrl ? decodeURIComponent(returnUrl) : '/';
            
            // 通过JS Bridge通知APP登录成功，并传递用户信息
            sendUserLoginToApp({
                userId: userId,
            });
            
            switch (accStatus) {
                case 0:
                    window.location.href = `/regist2?accId=${accId}`;
                    break;
                case 1:
                    setTimeout(() => {
                        window.location.href = '/waiting';
                    }, 500);
                    break;
                case 2:
                    setTimeout(() => {
                        window.location.href = returnUrl;
                    }, 500);
                    break;
                default:
                    setTimeout(() => {
                        window.location.href = returnUrl;
                    }, 500);
                    break;
            }
        } else {
            message.error('登录失败');
        }
    };

    return (
        <div className='loginBanner'>
            {/* <PWAInstall /> */}
            <Form
                form={loginForm}
                id='loginForm'
                name="basic"
                action="/login"
                method='post'
                style={{ width: '90%' }}
                autoComplete="off"
                className="loginForm"
            >
                <p style={{ marginTop: "0" }}>登录优选到家系统</p>
                {/* <div style={{ margin: '0 0 20px 0' }}>
                    <Radio.Group
                        name="radioGroup"
                        defaultValue={1}
                        buttonStyle="solid"
                    >
                        <Radio.Button value={1}>密码登录</Radio.Button>
                        <Radio.Button value={2}>短信登录</Radio.Button>
                    </Radio.Group>
                </div> */}
                <Form.Item
                    label=""
                    name="phoneNo"
                    rules={[
                        {
                            required: true,
                            message: '请输入手机号',
                        },
                    ]}
                >
                    <Input placeholder='手机号' />
                </Form.Item>
                <Form.Item
                    label=""
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: '请输入密码!',
                        },
                    ]}
                >
                    <Input placeholder='请输入密码' type='password' />
                </Form.Item>
                {/* <Flex gap={10} wrap>
                    <Form.Item
                        label=""
                        name="code"
                        rules={[
                            {
                                required: true,
                                message: '请输入验证码!',
                            },
                        ]}
                    >
                        <Input placeholder='验证码' />
                    </Form.Item>
                    <Button>
                        获取验证码
                    </Button>
                </Flex> */}
                <div style={{display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                    <Button href='/regist' type='default' style={{ width: "100%", background: "#ffffff" }}>
                        注册
                    </Button>
                    <Button type='primary' onClick={onSubmit} htmlType="submit" style={{ width: "100%", background: "#F44336" }}>
                        登录
                    </Button>
                </div>
            </Form>
        </div>

    )
}

export default Login;